// M01 數系與近似值 - 練習題數據 (主題 1-5)
// 系統化設計，準備後續 Supabase 數據遷移
// 每個主題 10 題，共 50 題

// ========== 1. 科學記數法轉換 (10題) ==========
export const M01_01_PROBLEMS = [
  {
    id: 'M01_01_P001',
    topicId: 'M01_01',
    question: "將 0.000045 轉換為科學記數法",
    solution: "4.5 × 10⁻⁵",
    explanation: "將小數點移動5位到右邊，指數為-5",
    hint: "數小數點前有幾個0，指數就是負幾",
    difficulty: 1,
    order: 1,
    steps: ["0.000045", "= 0.000045", "= 4.5 × 10⁻⁵"]
  },
  {
    id: 'M01_01_P002',
    topicId: 'M01_01',
    question: "將 567000 轉換為科學記數法",
    solution: "5.67 × 10⁵",
    explanation: "將小數點移動5位到左邊，指數為5",
    hint: "大數的指數等於小數點移動的位數",
    difficulty: 1,
    order: 2,
    steps: ["567000", "= 567000.0", "= 5.67 × 10⁵"]
  },
  {
    id: 'M01_01_P003',
    topicId: 'M01_01',
    question: "將 0.0078 轉換為科學記數法",
    solution: "7.8 × 10⁻³",
    explanation: "將小數點移動3位到右邊，指數為-3",
    hint: "小數點後第一個非零數字前的0的個數決定指數",
    difficulty: 1,
    order: 3,
    steps: ["0.0078", "= 0.0078", "= 7.8 × 10⁻³"]
  },
  {
    id: 'M01_01_P004',
    topicId: 'M01_01',
    question: "將 2340000 轉換為科學記數法",
    solution: "2.34 × 10⁶",
    explanation: "將小數點移動6位到左邊，指數為6",
    hint: "從右邊數，有6個0要移過去",
    difficulty: 1,
    order: 4,
    steps: ["2340000", "= 2340000.0", "= 2.34 × 10⁶"]
  },
  {
    id: 'M01_01_P005',
    topicId: 'M01_01',
    question: "將 8.9 × 10⁴ 轉換為普通記數法",
    solution: "89000",
    explanation: "將小數點向右移動4位",
    hint: "正指數表示小數點向右移",
    difficulty: 1,
    order: 5,
    steps: ["8.9 × 10⁴", "= 8.9 × 10000", "= 89000"]
  },
  {
    id: 'M01_01_P006',
    topicId: 'M01_01',
    question: "將 3.45 × 10⁻² 轉換為普通記數法",
    solution: "0.0345",
    explanation: "將小數點向左移動2位",
    hint: "負指數表示小數點向左移",
    difficulty: 1,
    order: 6,
    steps: ["3.45 × 10⁻²", "= 3.45 × 0.01", "= 0.0345"]
  },
  {
    id: 'M01_01_P007',
    topicId: 'M01_01',
    question: "將 1.23 × 10⁷ 轉換為普通記數法",
    solution: "12300000",
    explanation: "將小數點向右移動7位",
    hint: "指數7表示要補6個0",
    difficulty: 2,
    order: 7,
    steps: ["1.23 × 10⁷", "= 1.23 × 10000000", "= 12300000"]
  },
  {
    id: 'M01_01_P008',
    topicId: 'M01_01',
    question: "將 0.000000012 轉換為科學記數法",
    solution: "1.2 × 10⁻⁸",
    explanation: "將小數點移動8位到右邊，指數為-8",
    hint: "小數點後有8位才到第一個非零數字",
    difficulty: 2,
    order: 8,
    steps: ["0.000000012", "小數點移8位", "= 1.2 × 10⁻⁸"]
  },
  {
    id: 'M01_01_P009',
    topicId: 'M01_01',
    question: "將 4.56 × 10⁻⁶ 轉換為普通記數法",
    solution: "0.00000456",
    explanation: "將小數點向左移動6位",
    hint: "負6表示要在前面補5個0",
    difficulty: 2,
    order: 9,
    steps: ["4.56 × 10⁻⁶", "小數點左移6位", "= 0.00000456"]
  },
  {
    id: 'M01_01_P010',
    topicId: 'M01_01',
    question: "比較大小：3.2 × 10⁻⁴ 和 4.1 × 10⁻⁵",
    solution: "3.2 × 10⁻⁴ > 4.1 × 10⁻⁵",
    explanation: "指數較大的數較大，-4 > -5",
    hint: "先比較指數，再比較係數",
    difficulty: 2,
    order: 10,
    steps: ["比較指數：-4 > -5", "所以 3.2 × 10⁻⁴ 較大"]
  }
];

// ========== 2. 有效數字處理 (10題) ==========
export const M01_02_PROBLEMS = [
  {
    id: 'M01_02_P001',
    topicId: 'M01_02',
    question: "計算 3.14 × 2.1，並以適當有效數字表示",
    solution: "6.6",
    explanation: "2.1只有2個有效數字，所以答案也是2個有效數字",
    hint: "結果的有效數字取決於最少有效數字的數",
    difficulty: 2,
    order: 1,
    steps: ["3.14 × 2.1 = 6.594", "2.1有2個有效數字", "答案：6.6"]
  },
  {
    id: 'M01_02_P002',
    topicId: 'M01_02',
    question: "0.00450 有多少個有效數字？",
    solution: "3個",
    explanation: "4, 5, 0都是有效數字，前面的0只是佔位符",
    hint: "前導零不算有效數字",
    difficulty: 1,
    order: 2,
    steps: ["0.00450", "前面的0不算", "4, 5, 0 是有效數字"]
  },
  {
    id: 'M01_02_P003',
    topicId: 'M01_02',
    question: "計算 12.5 + 3.47，並以適當有效數字表示",
    solution: "16.0",
    explanation: "12.5的小數位數較少，所以結果保留到小數後1位",
    hint: "加減法看小數位數",
    difficulty: 2,
    order: 3,
    steps: ["12.5 + 3.47 = 15.97", "12.5只到小數後1位", "答案：16.0"]
  },
  {
    id: 'M01_02_P004',
    topicId: 'M01_02',
    question: "308000 有多少個有效數字？",
    solution: "不確定，需要更多資訊",
    explanation: "末尾的0可能是有效數字也可能不是，需要科學記數法來明確",
    hint: "末尾零的有效性需要額外說明",
    difficulty: 3,
    order: 4,
    steps: ["308000", "末尾0不確定", "需要科學記數法明確"]
  },
  {
    id: 'M01_02_P005',
    topicId: 'M01_02',
    question: "計算 45.6 ÷ 1.2，並以適當有效數字表示",
    solution: "38",
    explanation: "1.2只有2個有效數字，所以答案也是2個有效數字",
    hint: "除法的有效數字規則同乘法",
    difficulty: 2,
    order: 5,
    steps: ["45.6 ÷ 1.2 = 38.0", "1.2有2個有效數字", "答案：38"]
  },
  {
    id: 'M01_02_P006',
    topicId: 'M01_02',
    question: "2.00 × 3.0，並以適當有效數字表示",
    solution: "6.0",
    explanation: "3.0只有2個有效數字，所以答案也是2個有效數字",
    hint: "小數點後的0是有效數字",
    difficulty: 2,
    order: 6,
    steps: ["2.00 × 3.0 = 6.00", "3.0有2個有效數字", "答案：6.0"]
  },
  {
    id: 'M01_02_P007',
    topicId: 'M01_02',
    question: "0.0205 有多少個有效數字？",
    solution: "3個",
    explanation: "2, 0, 5都是有效數字",
    hint: "中間的0是有效數字",
    difficulty: 1,
    order: 7,
    steps: ["0.0205", "前面的0不算", "2, 0, 5 是有效數字"]
  },
  {
    id: 'M01_02_P008',
    topicId: 'M01_02',
    question: "計算 (2.4 × 10³) × (1.5 × 10²)，以適當有效數字表示",
    solution: "3.6 × 10⁵",
    explanation: "兩數都有2個有效數字，結果也是2個有效數字",
    hint: "科學記數法不影響有效數字規則",
    difficulty: 2,
    order: 8,
    steps: ["2.4 × 1.5 = 3.6", "10³ × 10² = 10⁵", "答案：3.6 × 10⁵"]
  },
  {
    id: 'M01_02_P009',
    topicId: 'M01_02',
    question: "5.600 有多少個有效數字？",
    solution: "4個",
    explanation: "小數點後的0都是有效數字",
    hint: "小數點明確顯示精度",
    difficulty: 1,
    order: 9,
    steps: ["5.600", "小數點後的0有效", "5, 6, 0, 0 都是有效數字"]
  },
  {
    id: 'M01_02_P010',
    topicId: 'M01_02',
    question: "計算 √(4.0 × 9.0)，以適當有效數字表示",
    solution: "6.0",
    explanation: "兩數都有2個有效數字，結果也是2個有效數字",
    hint: "開方運算同樣遵循有效數字規則",
    difficulty: 2,
    order: 10,
    steps: ["√(4.0 × 9.0) = √36 = 6", "原數有2個有效數字", "答案：6.0"]
  }
];

// ========== 3. 科學記數法乘法 (10題) ==========
export const M01_03_PROBLEMS = [
  {
    id: 'M01_03_P001',
    topicId: 'M01_03',
    question: "計算 (2.5 × 10³) × (4.0 × 10²)",
    solution: "1.0 × 10⁶",
    explanation: "係數相乘，指數相加：2.5 × 4.0 = 10.0，10³ × 10² = 10⁵，結果 = 10.0 × 10⁵ = 1.0 × 10⁶",
    hint: "係數乘係數，指數加指數",
    difficulty: 2,
    order: 1,
    steps: ["係數：2.5 × 4.0 = 10.0", "指數：3 + 2 = 5", "10.0 × 10⁵ = 1.0 × 10⁶"]
  },
  {
    id: 'M01_03_P002',
    topicId: 'M01_03',
    question: "計算 (3.2 × 10⁻⁴) × (2.0 × 10⁶)",
    solution: "6.4 × 10²",
    explanation: "係數相乘，指數相加：3.2 × 2.0 = 6.4，10⁻⁴ × 10⁶ = 10²",
    hint: "負指數加正指數",
    difficulty: 2,
    order: 2,
    steps: ["係數：3.2 × 2.0 = 6.4", "指數：-4 + 6 = 2", "答案：6.4 × 10²"]
  },
  {
    id: 'M01_03_P003',
    topicId: 'M01_03',
    question: "計算 (1.5 × 10⁵) × (4.0 × 10⁻³)",
    solution: "6.0 × 10²",
    explanation: "係數相乘，指數相加：1.5 × 4.0 = 6.0，10⁵ × 10⁻³ = 10²",
    hint: "正指數加負指數",
    difficulty: 2,
    order: 3,
    steps: ["係數：1.5 × 4.0 = 6.0", "指數：5 + (-3) = 2", "答案：6.0 × 10²"]
  },
  {
    id: 'M01_03_P004',
    topicId: 'M01_03',
    question: "計算 (7.2 × 10⁻²) × (5.0 × 10⁻³)",
    solution: "3.6 × 10⁻⁴",
    explanation: "係數相乘，指數相加：7.2 × 5.0 = 36.0 = 3.6 × 10¹，10⁻² × 10⁻³ = 10⁻⁵，結果 = 3.6 × 10¹ × 10⁻⁵ = 3.6 × 10⁻⁴",
    hint: "係數大於10時要調整",
    difficulty: 3,
    order: 4,
    steps: ["係數：7.2 × 5.0 = 36.0", "指數：-2 + (-3) = -5", "36.0 × 10⁻⁵ = 3.6 × 10⁻⁴"]
  },
  {
    id: 'M01_03_P005',
    topicId: 'M01_03',
    question: "計算 (8.1 × 10⁴) × (3.0 × 10⁻⁷)",
    solution: "2.4 × 10⁻²",
    explanation: "係數相乘，指數相加：8.1 × 3.0 = 24.3 = 2.43 × 10¹，10⁴ × 10⁻⁷ = 10⁻³，結果 = 2.43 × 10¹ × 10⁻³ = 2.4 × 10⁻²",
    hint: "注意有效數字處理",
    difficulty: 3,
    order: 5,
    steps: ["係數：8.1 × 3.0 = 24.3", "指數：4 + (-7) = -3", "24.3 × 10⁻³ = 2.4 × 10⁻²"]
  },
  {
    id: 'M01_03_P006',
    topicId: 'M01_03',
    question: "計算 (6.0 × 10⁻⁵) × (2.5 × 10⁸)",
    solution: "1.5 × 10⁴",
    explanation: "係數相乘，指數相加：6.0 × 2.5 = 15.0 = 1.5 × 10¹，10⁻⁵ × 10⁸ = 10³，結果 = 1.5 × 10¹ × 10³ = 1.5 × 10⁴",
    hint: "大數乘小數",
    difficulty: 2,
    order: 6,
    steps: ["係數：6.0 × 2.5 = 15.0", "指數：-5 + 8 = 3", "15.0 × 10³ = 1.5 × 10⁴"]
  },
  {
    id: 'M01_03_P007',
    topicId: 'M01_03',
    question: "計算 (9.6 × 10⁻⁶) × (1.25 × 10⁹)",
    solution: "1.2 × 10⁴",
    explanation: "係數相乘，指數相加：9.6 × 1.25 = 12.0 = 1.2 × 10¹，10⁻⁶ × 10⁹ = 10³，結果 = 1.2 × 10¹ × 10³ = 1.2 × 10⁴",
    hint: "小心計算係數乘法",
    difficulty: 3,
    order: 7,
    steps: ["係數：9.6 × 1.25 = 12.0", "指數：-6 + 9 = 3", "12.0 × 10³ = 1.2 × 10⁴"]
  },
  {
    id: 'M01_03_P008',
    topicId: 'M01_03',
    question: "計算 (4.8 × 10⁻³) × (2.1 × 10⁻⁴)",
    solution: "1.0 × 10⁻⁶",
    explanation: "係數相乘，指數相加：4.8 × 2.1 = 10.08 = 1.008 × 10¹，10⁻³ × 10⁻⁴ = 10⁻⁷，結果 = 1.008 × 10¹ × 10⁻⁷ = 1.0 × 10⁻⁶",
    hint: "兩個小數相乘",
    difficulty: 3,
    order: 8,
    steps: ["係數：4.8 × 2.1 = 10.08", "指數：-3 + (-4) = -7", "10.08 × 10⁻⁷ = 1.0 × 10⁻⁶"]
  },
  {
    id: 'M01_03_P009',
    topicId: 'M01_03',
    question: "計算 (3.6 × 10⁷) × (5.0 × 10⁻¹¹)",
    solution: "1.8 × 10⁻³",
    explanation: "係數相乘，指數相加：3.6 × 5.0 = 18.0 = 1.8 × 10¹，10⁷ × 10⁻¹¹ = 10⁻⁴，結果 = 1.8 × 10¹ × 10⁻⁴ = 1.8 × 10⁻³",
    hint: "大正指數乘大負指數",
    difficulty: 3,
    order: 9,
    steps: ["係數：3.6 × 5.0 = 18.0", "指數：7 + (-11) = -4", "18.0 × 10⁻⁴ = 1.8 × 10⁻³"]
  },
  {
    id: 'M01_03_P010',
    topicId: 'M01_03',
    question: "計算 (2.88 × 10⁵) × (4.0 × 10⁻⁷)",
    solution: "1.2 × 10⁻¹",
    explanation: "係數相乘，指數相加：2.88 × 4.0 = 11.52 = 1.152 × 10¹，10⁵ × 10⁻⁷ = 10⁻²，結果 = 1.152 × 10¹ × 10⁻² = 1.2 × 10⁻¹",
    hint: "注意最終有效數字",
    difficulty: 3,
    order: 10,
    steps: ["係數：2.88 × 4.0 = 11.52", "指數：5 + (-7) = -2", "11.52 × 10⁻² = 1.2 × 10⁻¹"]
  }
];

// ========== 4. 誤差計算 (10題) ==========
export const M01_04_PROBLEMS = [
  {
    id: 'M01_04_P001',
    topicId: 'M01_04',
    question: "測量值為 25.3 cm，真實值為 25.0 cm，求絕對誤差",
    solution: "0.3 cm",
    explanation: "絕對誤差 = |測量值 - 真實值| = |25.3 - 25.0| = 0.3 cm",
    hint: "絕對誤差是差值的絕對值",
    difficulty: 1,
    order: 1,
    steps: ["絕對誤差 = |測量值 - 真實值|", "= |25.3 - 25.0|", "= 0.3 cm"]
  },
  {
    id: 'M01_04_P002',
    topicId: 'M01_04',
    question: "測量值為 12.8 g，真實值為 13.0 g，求相對誤差",
    solution: "-0.0154 或 -1.54%",
    explanation: "相對誤差 = (測量值 - 真實值) / 真實值 = (12.8 - 13.0) / 13.0 = -0.0154",
    hint: "相對誤差可以是負數",
    difficulty: 2,
    order: 2,
    steps: ["相對誤差 = (測量值 - 真實值) / 真實值", "= (12.8 - 13.0) / 13.0", "= -0.2 / 13.0 = -0.0154"]
  },
  {
    id: 'M01_04_P003',
    topicId: 'M01_04',
    question: "測量長度為 45.2 mm，真實值為 45.0 mm，求百分誤差",
    solution: "0.44%",
    explanation: "百分誤差 = |(測量值 - 真實值) / 真實值| × 100% = |0.2 / 45.0| × 100% = 0.44%",
    hint: "百分誤差是相對誤差的絕對值乘以100%",
    difficulty: 2,
    order: 3,
    steps: ["百分誤差 = |(測量值 - 真實值) / 真實值| × 100%", "= |(45.2 - 45.0) / 45.0| × 100%", "= 0.44%"]
  },
  {
    id: 'M01_04_P004',
    topicId: 'M01_04',
    question: "電阻測量值為 98.5 Ω，標準值為 100 Ω，求絕對誤差和相對誤差",
    solution: "絕對誤差：1.5 Ω，相對誤差：-1.5%",
    explanation: "絕對誤差 = |98.5 - 100| = 1.5 Ω，相對誤差 = (98.5 - 100) / 100 = -1.5%",
    hint: "先算絕對誤差，再算相對誤差",
    difficulty: 2,
    order: 4,
    steps: ["絕對誤差 = |98.5 - 100| = 1.5 Ω", "相對誤差 = (98.5 - 100) / 100 = -1.5%"]
  },
  {
    id: 'M01_04_P005',
    topicId: 'M01_04',
    question: "溫度計讀數為 22.8°C，實際溫度為 23.0°C，求百分誤差",
    solution: "0.87%",
    explanation: "百分誤差 = |(22.8 - 23.0) / 23.0| × 100% = 0.87%",
    hint: "百分誤差總是正數",
    difficulty: 2,
    order: 5,
    steps: ["百分誤差 = |(測量值 - 真實值) / 真實值| × 100%", "= |(22.8 - 23.0) / 23.0| × 100%", "= 0.87%"]
  },
  {
    id: 'M01_04_P006',
    topicId: 'M01_04',
    question: "天平讀數為 250.3 g，物體真實質量為 250.0 g，求相對誤差（以分數表示）",
    solution: "3/2500 或 0.0012",
    explanation: "相對誤差 = (250.3 - 250.0) / 250.0 = 0.3 / 250.0 = 3/2500",
    hint: "可以用分數表示更精確",
    difficulty: 2,
    order: 6,
    steps: ["相對誤差 = (250.3 - 250.0) / 250.0", "= 0.3 / 250.0", "= 3/2500"]
  },
  {
    id: 'M01_04_P007',
    topicId: 'M01_04',
    question: "速度測量值為 59.8 km/h，真實值為 60.0 km/h，求百分誤差",
    solution: "0.33%",
    explanation: "百分誤差 = |(59.8 - 60.0) / 60.0| × 100% = 0.33%",
    hint: "小數要四捨五入到適當位數",
    difficulty: 2,
    order: 7,
    steps: ["百分誤差 = |(59.8 - 60.0) / 60.0| × 100%", "= |(-0.2) / 60.0| × 100%", "= 0.33%"]
  },
  {
    id: 'M01_04_P008',
    topicId: 'M01_04',
    question: "電壓表讀數為 9.85 V，標準電壓為 10.00 V，求絕對誤差和百分誤差",
    solution: "絕對誤差：0.15 V，百分誤差：1.5%",
    explanation: "絕對誤差 = |9.85 - 10.00| = 0.15 V，百分誤差 = 0.15 / 10.00 × 100% = 1.5%",
    hint: "兩個計算要分別進行",
    difficulty: 2,
    order: 8,
    steps: ["絕對誤差 = |9.85 - 10.00| = 0.15 V", "百分誤差 = 0.15 / 10.00 × 100% = 1.5%"]
  },
  {
    id: 'M01_04_P009',
    topicId: 'M01_04',
    question: "時間測量值為 2.48 s，精確值為 2.50 s，求相對誤差（保留4位小數）",
    solution: "-0.0080",
    explanation: "相對誤差 = (2.48 - 2.50) / 2.50 = -0.02 / 2.50 = -0.0080",
    hint: "負號表示測量值小於真實值",
    difficulty: 2,
    order: 9,
    steps: ["相對誤差 = (2.48 - 2.50) / 2.50", "= -0.02 / 2.50", "= -0.0080"]
  },
  {
    id: 'M01_04_P010',
    topicId: 'M01_04',
    question: "壓力測量值為 101.8 kPa，標準大氣壓為 101.3 kPa，求百分誤差",
    solution: "0.49%",
    explanation: "百分誤差 = |(101.8 - 101.3) / 101.3| × 100% = 0.49%",
    hint: "大氣壓的誤差通常很小",
    difficulty: 2,
    order: 10,
    steps: ["百分誤差 = |(101.8 - 101.3) / 101.3| × 100%", "= |0.5 / 101.3| × 100%", "= 0.49%"]
  }
];

// ========== 5. 近似值計算 (10題) ==========
export const M01_05_PROBLEMS = [
  {
    id: 'M01_05_P001',
    topicId: 'M01_05',
    question: "將 3.14159 四捨五入至小數後2位",
    solution: "3.14",
    explanation: "小數後第3位是1，小於5，所以捨去",
    hint: "看要保留位數的下一位決定捨入",
    difficulty: 1,
    order: 1,
    steps: ["3.14159", "小數後第3位是1 < 5", "捨去，答案：3.14"]
  },
  {
    id: 'M01_05_P002',
    topicId: 'M01_05',
    question: "將 2.7183 四捨五入至小數後3位",
    solution: "2.718",
    explanation: "小數後第4位是3，小於5，所以捨去",
    hint: "第4位的3小於5要捨去",
    difficulty: 1,
    order: 2,
    steps: ["2.7183", "小數後第4位是3 < 5", "捨去，答案：2.718"]
  },
  {
    id: 'M01_05_P003',
    topicId: 'M01_05',
    question: "將 45.678 四捨五入至整數",
    solution: "46",
    explanation: "小數後第1位是6，大於等於5，所以進位",
    hint: "6 ≥ 5 要進位",
    difficulty: 1,
    order: 3,
    steps: ["45.678", "小數後第1位是6 ≥ 5", "進位，答案：46"]
  },
  {
    id: 'M01_05_P004',
    topicId: 'M01_05',
    question: "將 123.456 四捨五入至十位",
    solution: "120",
    explanation: "個位數是3，小於5，所以捨去，個位變為0",
    hint: "捨去個位，個位變0",
    difficulty: 2,
    order: 4,
    steps: ["123.456", "個位數是3 < 5", "捨去，答案：120"]
  },
  {
    id: 'M01_05_P005',
    topicId: 'M01_05',
    question: "將 0.08765 四捨五入至小數後3位",
    solution: "0.088",
    explanation: "小數後第4位是6，大於等於5，所以第3位的7進位為8",
    hint: "6 ≥ 5，第3位要進位",
    difficulty: 2,
    order: 5,
    steps: ["0.08765", "小數後第4位是6 ≥ 5", "第3位進位：0.088"]
  },
  {
    id: 'M01_05_P006',
    topicId: 'M01_05',
    question: "將 9.995 四捨五入至小數後2位",
    solution: "10.00",
    explanation: "小數後第3位是5，進位使第2位的9變為10，需要進位到整數部分",
    hint: "連續進位到整數部分",
    difficulty: 3,
    order: 6,
    steps: ["9.995", "第3位是5 ≥ 5，第2位進位", "9.99 + 0.01 = 10.00"]
  },
  {
    id: 'M01_05_P007',
    topicId: 'M01_05',
    question: "將 567.89 四捨五入至百位",
    solution: "600",
    explanation: "十位數是6，大於等於5，所以百位的5進位為6，十位和個位都變為0",
    hint: "十位6 ≥ 5，百位要進位",
    difficulty: 2,
    order: 7,
    steps: ["567.89", "十位數是6 ≥ 5", "百位進位：600"]
  },
  {
    id: 'M01_05_P008',
    topicId: 'M01_05',
    question: "將 0.000456 四捨五入至小數後5位",
    solution: "0.00046",
    explanation: "小數後第6位是6，大於等於5，所以第5位的5進位為6",
    hint: "很小的數也要按規則進位",
    difficulty: 2,
    order: 8,
    steps: ["0.000456", "第6位是6 ≥ 5", "第5位進位：0.00046"]
  },
  {
    id: 'M01_05_P009',
    topicId: 'M01_05',
    question: "將 π ≈ 3.14159265 四捨五入至小數後4位",
    solution: "3.1416",
    explanation: "小數後第5位是9，大於等於5，所以第4位的5進位為6",
    hint: "π的近似值計算",
    difficulty: 2,
    order: 9,
    steps: ["3.14159265", "第5位是9 ≥ 5", "第4位進位：3.1416"]
  },
  {
    id: 'M01_05_P010',
    topicId: 'M01_05',
    question: "將 1999.5 四捨五入至千位",
    solution: "2000",
    explanation: "百位數是9，小數部分是0.5 ≥ 0.5，所以要進位，1999 + 1 = 2000",
    hint: "跨千位的進位",
    difficulty: 3,
    order: 10,
    steps: ["1999.5", "小數部分0.5 ≥ 0.5", "整數部分進位：2000"]
  }
]; 